import config from 'veui/managers/config'

config.defaults(
  {
    ui: {
      reverse: {
        boolean: true
      }
    }
  },
  'tooltip'
)
